import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Item } from '../Item/Item';
import { ClassificationDTO } from '../../api/useAssetBucketQuery';

interface Props extends ClassificationDTO {
  id: number;
  remove?(): void;
  bucketIndex?: number;
}

export const DraggableItem: React.FC<Props> = props => {
  const { id, bucketIndex, remove, ...classification } = props;

  const { attributes, listeners, setNodeRef } = useDraggable({
    id: `${id}`,
    data: { classification, bucketIndex },
  });

  return (
    <Box ref={setNodeRef} width="100%">
      <Item
        {...props}
        remove={remove}
        handleProps={{
          ...attributes,
          ...listeners,
        }}
      />
    </Box>
  );
};
